export default function getters() {
	return {
		getCurrentUser: state => state.user,
		isLoggedIn: state => state.user !== null,
		isAdmin: (state, getters) =>
			getters.isLoggedIn ? state.user.type === 'admin' || state.user.type === 'superadmin' : false,
		isCustomerService: (state, getters) => {
			if(!getters.isLoggedIn) {
				return false;
			}

			const hasRole = state.user.roles.filter(role => role.name === 'Ügyfélszolgálat');
			return getters.isLoggedIn ? state.user.type === 'consultant' && hasRole.length > 0 : false;
		},
		isConsultant: (state, getters) => (getters.isLoggedIn ? state.user.type === 'consultant' : false),
		isUser: (state, getters) => (getters.isLoggedIn ? state.user.type === 'user' : true),
		isVerified: (state, getters) => (getters.isLoggedIn ? state.user.email_verified_at !== null : false),
		getClients: state => state.user.clients,
        getUserList: state => state.userList,
        getBikaUserList: state => state.BIKAListResponse.users,
        getBikaUserListError: state => state.BIKAListResponse.error,
        getBikaUserListErrorMsg: state => state.BIKAListResponse.message,
        getIsSimpleRegistration: state => state.simpleRegistration,
        getSimpleRegistrationEmail: state => state.simpleRegistrationEmail,
	};
}
